import * as IkeModel from '@ikegps/core-shared';
import type { MithrilVNode } from '../../../mithril';
import type { ICollectionViewController } from '../collection.view.ctrl.interface';

export interface CollectionFieldView<T extends IkeModel.CollectionModelField = IkeModel.CollectionModelField> {
	/** View field as read-only and fitting on a single line. */
	viewInline(field: T, ctrl: ICollectionViewController): MithrilVNode | string;

	/** View more information about field. Only invoked if `hasDetail()` returns true. */
	viewDetail(field: T): MithrilVNode;

	/** View field as editable. */
	viewEdit(field: T, ctrl: ICollectionViewController): MithrilVNode | string;

	/** Whether the field has more information to display */
	hasDetail?(field: T): boolean;

	/** Whether the field can be cleared. */
	hasClear?(field: T): boolean;

	/** Whether the field can be populated with geocoding api. */
	canGeocoding?(field: T): boolean;

	/** Whether the field has file to download. */
	hasFile?(field: T): boolean;

	/** Whether the field has a file to upload */
	canUpload?(field: T): boolean;
}

export const SimpleFieldView: CollectionFieldView = {
	viewInline(field: IkeModel.CollectionModelField): string {
		return field.displayValue;
	},

	viewDetail(field: IkeModel.CollectionModelField): MithrilVNode {
		return null;
	},

	viewEdit(field: IkeModel.CollectionModelField, ctrl: ICollectionViewController): MithrilVNode | string {
		return SimpleFieldView.viewInline(field, ctrl);
	},
};
